<div class="w-full" #container>
  <canvas #canvas></canvas>
</div>